import Model from './Model';

export default class Leave extends Model {
  resource() {
    return 'leaves';
  }
}
